export default __webpack_public_path__ + "static/kosiec-3cf18d36280967be835a977a2ca5a59e.jpg";